// extracted by mini-css-extract-plugin
export default {"\t":"index_-__Kr+dt","inputSearch":"index_inputSearch__N5PEx","isFocus":"index_isFocus__skeJt","searchButton":"index_searchButton__LCVkE"};